import { useEffect, useState } from 'react';
import { FlexStack } from '~/components/atomic';
import { PasswordInput } from '~/components/common';
import { passwordsValidAndMatch } from '~/utils';
import { useSignUpStepStore } from '~/store';
import InnerLayout from '../Layout/InnerLayout';

interface CreatePasswordProps {
  onNextStep: () => void;
}

export default function CreatePassword({ onNextStep }: CreatePasswordProps) {
  const { password, setPassword } = useSignUpStepStore((state) => ({
    password: state.createPassword.password,
    setPassword: state.setPassword,
  }));
  const setSubProgress = useSignUpStepStore((state) => state.setSubProgress);
  const [confirmPassword, setConfirmPassword] = useState('');

  const validAndMatch = passwordsValidAndMatch(password, confirmPassword);

  useEffect(() => {
    setSubProgress(validAndMatch ? 1 : 0.5);
  }, [validAndMatch, setSubProgress]);

  const buttonProps = {
    title: 'Next',
    disabled: !validAndMatch,
    onClick: onNextStep,
  };

  return (
    <InnerLayout buttonProps={buttonProps}>
      <FlexStack spacing={32}>
        <PasswordInput
          placeholder='Password'
          text={password}
          setText={setPassword}
          checkingPasswordOpt
        />
        <PasswordInput
          placeholder='Confirm password'
          text={confirmPassword}
          setText={setConfirmPassword}
          checkingPasswordOpt
          confirm
          password={password}
        />
      </FlexStack>
    </InnerLayout>
  );
}
